<template>
    <div id="Critical-Shortages" class="wrapper m0-50 critical">
        <div class="section">
            <div class="div-block-15">
                <div class="form-container">
                    <div class="form-block w-form">
                        <form v-if="!success&&!fail" id="wf-form-Offer-Input-Materials---Hand-Sanitizer" name="wf-form-Offer-Input-Materials---Hand-Sanitizer" data-name="Offer Input Materials - Hand Sanitizer" class="form-wrapper"
                              @submit.prevent="submit">
                            <div class="form-title-container">
                                <div class="form-title">Offer Input Materials/Services - {{$route.params.productName}}<a href="https://prospero-uikit.webflow.io/2-content#"><strong><br></strong></a></div>
                                <p>Please review the <a href="https://buyandsell.gc.ca/specifications-for-COVID-19-products#600" target="_blank" class="link-blue">Government of Canada&#x27;s Product Specifications</a> prior to completing the form below.</p>
                            </div>
                            <div class="input-container"><label class="input-group-label">Offer Details</label>
                                <div class="input-container">
                                    <label class="input-label">Type of Production Capacity, Ingredient, Component or Service you can provide:</label>
                                    <select v-model="form.material" id="Material" name="Material" data-name="Material" class="w-select">
                                        <option value="">Select one...</option>
                                        <option v-for="material in actualMaterials" v-bind:key="material.id" :value="material">{{material.description}}</option>
                                    </select>
                                </div>
                                <div class="input-container">
                                    <label class="input-label">Which provinces can you deliver products/services to?</label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="All Provinces" value="All">
                                        <span class="checkbox-label w-form-label">All</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="No Province, Require Assistance" value="None" data-name="No Province, Require Assistance" >
                                        <span class="checkbox-label w-form-label">None, I will require assistance to deliver my products/services</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="AB" value="AB" data-name="AB" >
                                        <span class="checkbox-label w-form-label">AB</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="BC" value="British-Columbia" data-name="BC" >
                                        <span class="checkbox-label w-form-label">BC</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="MB" value="MB" data-name="MB" >
                                        <span class="checkbox-label w-form-label">MB</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="NB" value="New-Brunswick" data-name="NB" >
                                        <span class="checkbox-label w-form-label">NB</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="NL" value="Newfoundland-and-Labrador" data-name="NL" >
                                        <span class="checkbox-label w-form-label">NL</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="NS" value="Nova-Scotia" data-name="NS" >
                                        <span class="checkbox-label w-form-label">NS</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="NT" value="Northwest-Territories" data-name="NT" >
                                        <span class="checkbox-label w-form-label">NT</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="NU" value="NU" data-name="NU" >
                                        <span class="checkbox-label w-form-label">NU</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="ON" value="ON" data-name="ON" >
                                        <span class="checkbox-label w-form-label">ON</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="PE" value="Prince-Edward-Island" data-name="PE" >
                                        <span class="checkbox-label w-form-label">PE</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="QC" value="QC" data-name="QC" >
                                        <span class="checkbox-label w-form-label">QC</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="SK" value="SK" data-name="SK" >
                                        <span class="checkbox-label w-form-label">SK</span>
                                    </label>
                                    <label question="delivery-province" class="w-checkbox checkbox-field">
                                        <input type="checkbox" v-model="form.provinceArray" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"  id="YT" value="YT" data-name="YT" >
                                        <span class="checkbox-label w-form-label">YT</span>
                                    </label>
                                    <div class="text-red" v-if="$v.form.$error">
                                        <div v-if="!$v.form.provinceArray.required">At least one selection is required.</div>
                                    </div>
                                </div>
                                <div v-if="form.material.id == this.ingredientOptionID" class="input-container">
                                    <label class="input-label">Type of Production Capacity, Ingredients, Components or Services you can provide:</label>
                                    <select v-model="form.ingredient" id="ingredient" name="ingredient" data-name="ingredient" class="w-select">
                                        <option value="">Select one...</option>
                                        <option v-for="ingredient in this.ingredients" v-bind:key="ingredient.id" :value="ingredient">{{ingredient.description}}</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="(form.material.id == this.ingredientOptionID && form.ingredient) || (form.material.id != this.ingredientOptionID && form.material.id)" class="input-container">
                                <div id="materialDetails" class="group-input-container">
                                    <label v-if="form.material.id == this.ingredientOptionID" class="input-group-label">
                                        <strong v-if="this.form.ingredient.description">{{this.form.ingredient.description}}</strong>
                                        <strong v-else>Ingredient</strong>
                                    </label>
                                    <label v-else class="input-group-label"><strong>{{this.form.material.description}}</strong></label>
                                    <div class="input-container">
                                        <label v-if="form.material.id == this.ingredientOptionID" class="input-label">Description of the ingredient you are able to produce:</label>
                                        <label v-else class="input-label">Description of the product/service you are able to produce:</label>
                                        <input v-model="form.description" type="text"
                                               @blur="$v.form.description.$touch"
                                               class="text-input w-input" maxlength="256" placeholder="Your answer" id="description">
                                        <div class="text-red" v-if="$v.form.description.$error">
                                            <div v-if="!$v.form.description.required">A description is required</div>
                                        </div>
                                    </div>
                                    <div class="input-container">
                                        <label class="input-label">How many {{this.form.material.unitOfMeasure}} do you currently have available?</label>
                                        <input v-model="form.qtyAvailableNow" v-mask="'########'"
                                               @blur="$v.form.qtyAvailableNow.$touch()"
                                               type="text" class="text-input w-input"
                                               maxlength="256" placeholder="Your answer" id="Required-Units">
                                        <div class="text-red" v-if="$v.form.qtyAvailableNow.$error">
                                            <div v-if="!$v.form.qtyAvailableNow.required">A value of one or more is required</div>
                                            <div v-if="!$v.form.qtyAvailableNow.minValue">A value of one or more is required</div>
                                        </div>
                                    </div>
<!--                                    <div class="input-container">-->
<!--                                        <label class="input-label">How many {{this.form.material.unitOfMeasure}} can be produced per week?</label>-->
<!--                                        <input v-model="form.qtyProducedIn5Days" v-mask="'########'" type="text" class="text-input w-input" maxlength="256" placeholder="Your answer" id="Required-Production-Rate">-->
<!--                                        <div class="text-red" v-if="$v.form.$error">-->
<!--                                            <div v-if="!$v.form.qtyProducedIn5Days.required">A value of zero or more is required</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="input-container">-->
<!--                                        <label class="input-label">What is the average cost per unit?</label>-->
<!--                                        <input v-currency v-model="form.averageCostPerUnit" type="text" class="text-input w-input" maxlength="256" placeholder="Your answer">-->
<!--                                        <div class="text-red" v-if="$v.form.$error">-->
<!--                                            <div v-if="!$v.form.averageCostPerUnit.required">A price per unit is required</div>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                    <div v-if="form.material.id == this.ingredientOptionID" class="input-container">
                                        <label class="input-label">How do you deliver this ingredient?</label>
                                        <label class="w-checkbox checkbox-field">
                                            <input v-model="form.transportArray" type="checkbox" id="Tanker Truck (14,000 kg)" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Tanker Truck (14,000 kg)">
                                            <span class="checkbox-label w-form-label">Tanker Truck (14,000 kg)</span>
                                        </label>
                                        <label class="w-checkbox checkbox-field">
                                            <input v-model="form.transportArray" type="checkbox" id="Totes (1,000 kg)" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Totes (1,000 kg)">
                                            <span class="checkbox-label w-form-label">Totes (1,000 kg)</span>
                                        </label>
                                        <label class="w-checkbox checkbox-field">
                                            <input v-model="form.transportArray" type="checkbox" id="Drums (200 kg)" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="Drums (200kg)">
                                            <span class="checkbox-label w-form-label">Drums (200 kg)</span>
                                        </label>
                                        <label class="w-checkbox checkbox-field other">
                                            <div>
                                                <input v-model="form.transportArray" type="checkbox" id="Other Delivery Method" class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" value="other">
                                                <input v-model="form.otherDeliveryMethod" type="text" placeholder="Other..." class="text-input w-input" maxlength="256" id="Other-Delivery-Method-Description" style="padding-left: 10px">
                                            </div>
                                        </label>
                                        <div class="text-red" v-if="$v.form.$error">
                                            <div v-if="(!$v.form.transportArray.sometimesRequired)">A method of delivery is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input v-on:click="submit" type="button" value="Submit" data-wait="Please wait..." class="submit-button w-button">
                        </form>
                            <div v-if="validation||success||fail" class="form-block w-form">
                                <div class="form-success" v-if="success">
                                    <div>Thank you! Your submission has been received.<br><br>You will receive a confirmation email
                                        with information on managing your post.
                                    </div>
                                </div>
                                <div class="form-fail" v-if="fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                                <div class="input-container form-fail" v-if="validation">
                                    <div>Please verify that everything you've entered is correct.</div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {formService} from "../../assets/js/services/formService";
    import {required, minValue} from "vuelidate/lib/validators";

    export default {
        name: "OfferMaterials",
        data() {
            return {
                productArray: [],
                product: [],
                materials: [],
                actualMaterials: [],
                ingredients: [],
                ingredientOptionID: "",
                ingredientDeliveryMethods: "",
                otherIndex: "",
                form: {
                    provinceArray: [],
                    material: "",
                    ingredient: "",
                    transportArray: [],
                    description: "",
                    qtyAvailableNow: "",
                    qtyProducedIn5Days: "",
                    averageCostPerUnit: "",
                    otherDeliveryMethod: "",
                },
                supplies: [{
                    offerId: "",
                    productRequest: {
                        id: this.$route.params.id
                    },
                    materialRequest: {
                        id: "",
                        otherMaterial: false
                    },
                    description: "",
                    qtyAvailableNow: 0,
                    qtyProducedIn5Days: 0,
                    qtyProducedPerMonth: 0,
                    deliveredToCity: "",
                    deliveredToState: "",//Send comma delimited list
                    deliveredToCountry: "",
                    msdsLink: "",
                    q1SiteLicenses: null,
                    q2ProductApprovals: null,
                    q3SiteCompliance: null,
                    q4ExperienceBefore: null,
                    averageCostPerUnit: 0,
                    comments: "",
                    ingredientDeliveryMethod: "",
                    npn: 0
                }],
                success: false,
                fail: false,
                validation: false,
            }
        },
        created() {
            this.productArray = JSON.parse(localStorage.getItem('ProductsMaterialsList'));
            this.product = this.productArray.filter(p => p.productType == this.$route.params.productType);
            this.materials = this.product[0].materialList;
            this.actualMaterials = this.product[0].materialList.filter(m => m.ingredient == false);
            this.ingredients = this.product[0].materialList.filter(m => m.ingredient == true);
            this.ingredientOptionID = this.materials.filter(m => m.materialName == "Ingredients")[0].id;//Get the id of "Ingredients"
        },
        validations: {
            form: {
                description: {required},
                provinceArray: {required},
                //averageCostPerUnit: {required},
                qtyAvailableNow: {required, minValue: minValue(1)},
                //qtyProducedIn5Days: {required},
                transportArray: {
                    sometimesRequired(transportArray) {
                        if (this.form.ingredient.description) {//They've selected an ingredient
                            if (transportArray.length == 0) {//Make sure they entered a value
                                return false;
                            } else if (transportArray.indexOf("other") >= 0) {//If they chose other, make sure they entered something in the text box
                                if (!this.form.otherDeliveryMethod) {
                                    return false;
                                }
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                        return true;
                    }
                }
            }
        },
        methods: {
            submit() {
                this.validation = false;
                this.success = false;
                this.fail = false;

                this.$v.form.$touch();
                if(this.$v.form.$error){
                    this.validation = true;
                    return;
                }

                this.supplies[0].deliveredToState = this.form.provinceArray.toString();

                if(this.form.material.id == this.ingredientOptionID){//The user is selecting an ingredient
                    this.supplies[0].materialRequest.id = this.form.ingredient.id;
                    this.supplies[0].materialRequest.materialName = this.form.ingredient.materialName;
                    if (this.form.ingredient.materialName == "Other"){//The user has selected a non-standard ingredient
                        this.supplies[0].materialRequest.otherMaterial = true;
                    }
                    else {
                        this.supplies[0].materialRequest.otherMaterial = false;
                    }
                }
                else {//The user is selecting a material
                    this.supplies[0].materialRequest.id = this.form.material.id;
                    this.supplies[0].materialRequest.materialName = this.form.material.materialName;
                    if (this.form.material.materialName == "Other"){//The user has selected a non-standard material
                        this.supplies[0].materialRequest.otherMaterial = true;
                    }
                    else {
                        this.supplies[0].materialRequest.otherMaterial = false;
                    }
                }

                this.otherIndex = this.form.transportArray.indexOf("other");//Check to see if the user selected other
                if (this.otherIndex >= 0) {//They did
                    this.ingredientDeliveryMethods = this.form.transportArray;
                    this.ingredientDeliveryMethods.splice(this.otherIndex, 1, this.form.otherDeliveryMethod)//Splice in the value they entered in place of the 'other' placeholder
                } else {
                    this.ingredientDeliveryMethods = this.form.transportArray;
                }
                this.supplies[0].ingredientDeliveryMethod = this.ingredientDeliveryMethods.toString();

                this.supplies[0].description = this.form.description;
                this.supplies[0].qtyAvailableNow = this.form.qtyAvailableNow;
                this.supplies[0].qtyProducedIn5Days = this.form.qtyProducedIn5Days;
                this.supplies[0].averageCostPerUnit = this.$parseCurrency(this.form.averageCostPerUnit);

                formService.offerMaterials(this.supplies).then(() => {this.success = true;})
                    .catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.validation = true;
                        }
                        else {
                            this.fail = true;
                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>
